
import { prepareBrand } from '@/plugins/helpers/catalog';
import Brands from '@/components/elements/Brands';
import Breadcrumbs from '@/components/elements/Breadcrumbs';
import pageMeta from '~/mixins/pageMeta';

export default {
  name: 'BrandsPage',
  components: {
    Brands,
    Breadcrumbs,
  },
  mixins: [pageMeta],
  async asyncData({ $api, route, error, redirect }) {
    try {
      const { meta, brands } = await $api.general.getPage(route.path)

      if (!meta || meta?.status > 400) {
        return error({ statusCode: meta?.status || 404 })
      }

      if (meta?.redirect) {
        return redirect(meta.status, meta.redirect)
      }

      function getBrandList(list) {
        const itemsMap = {};

        list.forEach(brand => {
          const item = prepareBrand(brand);

          const letter = item.name.slice(0, 1).toUpperCase();
          const map = itemsMap[letter];

          if (!map) itemsMap[letter] = {
            id: letter,
            name: letter,
            items: [item],
          };
          else map.items.push(item);
        })

        return sortBrandList(itemsMap);
      }

      function sortBrandList(brandsMap) {
        return Object.keys(brandsMap)
          .map(key => brandsMap[key])
          .sort((a, b) => a.name.charCodeAt(0) - b.name.charCodeAt(0))
      }

      const brandList = getBrandList(brands)


      return {
        pageTitle: meta?.title || '',
        pageMetaData: meta?.data || [],
        pageLinks: meta?.links || [],
        brandList: brandList || [],
        breadcrumbsList: [
          {
            name: 'Главная',
            url: '/',
          },
          {
            name: 'Бренды',
            url: '',
          },
        ],
      };
    } catch (e) {
      return error({ statusCode: 404 })
    }
  },
};
